import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "../../api/axiosinstance";
import { motion } from "framer-motion";
import PageTransition from "../../components/PageTransition";
import { useNavigate } from "react-router-dom";

function DocumentView() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [html, setHtml] = useState("");

  const [actionDone, setActionDone] = useState(false);

  const [documentData, setDocumentData] = useState(null);

  const hasPrice = Number(documentData?.price || 0) > 0;

  // =====================================
  // LOAD
  // =====================================

  useEffect(() => {
    if (!id) return;

    fetchDocument();

    trackOpen();
  }, [id]);

  // =====================================
  // FETCH HTML
  // =====================================

  const fetchDocument = async () => {
    try {
      // =========================
      // FETCH DOCUMENT DETAILS
      // =========================

      const detailRes = await axios.get(`/documents/by-id/${id}`);

      console.log("FULL RESPONSE", detailRes);

      // ✅ IMPORTANT
      const document = detailRes;

      setDocumentData(document);

      // ✅ BASE PRICE
      const basePrice = Number(document?.price || 0);

      // ✅ ADDON TOTAL
      const addonTotal = Array.isArray(document?.commitments)
        ? document.commitments.reduce(
            (total, item) => total + Number(item?.price || 0),
            0,
          )
        : 0;

      const finalTotal = basePrice + addonTotal;

      console.log("BASE PRICE:", basePrice);

      console.log("ADDON TOTAL:", addonTotal);

      console.log("FINAL TOTAL:", finalTotal);

      // =========================
      // FETCH HTML
      // =========================

      const res = await fetch(
        `${process.env.REACT_APP_SOCKET_URL}api/v1/documents/public/${id}`,
      );

      const data = await res.text();

      // =========================
      // REPLACE TOTAL PRICE
      // =========================

      const replacedHtml = data.replace(
        /Total Price\s*:?\s*₹\s*[\d,]+/gi,
        `Total Price : ₹ ${finalTotal.toLocaleString("en-IN")}`,
      );

      // =========================
      // STYLED HTML
      // =========================

      const styledHtml = `
      <style>
        ul {
          list-style-type: disc;
          padding-left: 20px;
          margin-bottom: 10px;
        }

        ol {
          list-style-type: decimal;
          padding-left: 20px;
        }

        li {
          margin-bottom: 6px;
          font-size: 14px;
          color: #333;
          line-height: 22px;
        }

        body, p, span, h1 {
          font-size: 14px;
          color: #444;
        }
      </style>

      ${replacedHtml}
    `;

      setHtml(styledHtml);
    } catch (err) {
      console.log(err);
    }
  };

  // =====================================
  // FETCH DOCUMENT DETAILS
  // =====================================

  // const fetchDocumentDetails = async () => {
  //   try {
  //     const res = await axios.get(`/documents/by-id/${id}`);

  //     console.log("FULL RESPONSE", res);

  //     // ✅ IMPORTANT FIX
  //     setDocumentData(res);
  //   } catch (err) {
  //     console.log(err);
  //   }
  // };

  // =====================================
  // TRACK OPEN
  // =====================================

  const trackOpen = async () => {
    try {
      await axios.post("/documents/track-open", {
        documentId: id,
      });
    } catch (err) {
      console.log(err);
    }
  };

  // =====================================
  // HANDLE STATUS
  // =====================================

  const handleStatus = async (status) => {
    try {
      await axios.post("/documents/update-status", {
        documentId: id,
        status,
      });

      // =========================
      // CONTACT SALES
      // =========================

      if (status === "contact_sales") {
        setHtml(`
        <div style="padding:80px;text-align:center;font-size: 23px;font-weight: bold;">
          <h>Thank you for your response.</h

          <p style="margin-top:20px;font-size:18px;">
 📞 Sales Team Will Contact You Shortly          </p>
        </div>
      `);

        setActionDone(true);

        return;
      }

      // =========================
      // GET DOCUMENT
      // =========================

      const leadRes = await axios.get(`/documents/by-id/${id}`);

      console.log("🔥 DOCUMENT RESPONSE", leadRes);

      // ✅ IMPORTANT FIX
      const leadId = leadRes?.leadId?._id;
      console.log("🔥 FINAL LEAD ID", leadId);

      if (!leadId) {
        alert("Lead not found");

        return;
      }

      // =========================
      // CREATE AGREEMENT
      // =========================

      const agreementRes = await axios.post("/service-agreement/create", {
        leadId,
      });

      console.log("🔥 AGREEMENT RESPONSE", agreementRes);

      // ✅ IMPORTANT FIX
      const agreementId = agreementRes?.data?._id;
      console.log("🔥 AGREEMENT ID", agreementId);

      if (!agreementId) {
        alert("Agreement creation failed");

        return;
      }

      // =========================
      // REDIRECT
      // =========================
      navigate(`/agreement/view/${agreementId}`);
    } catch (err) {
      console.log("❌ ERROR", err);

      alert(err?.message || "Something went wrong");
    }
  };

  return (
    <PageTransition>
      <div className="document-wrapper">
        {/* LEFT STRIP */}

        <div className="left-strip" />

        {/* MAIN */}
        <div className="document-main">
          {/* top bar */}
          <div className="top-bar">
            <img
              src="/assets/img/logo.png"
              alt=""
              style={{
                width: "120px",
                marginBottom: "6px",
              }}
            />
            {/* INFO */}

            <div className="top-info">
              {/* LEFT */}

              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "6px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    gap: "10px",
                  }}
                >
                  <strong
                    style={{
                      color: "#5d5d5d",
                      fontSize: "14px",
                    }}
                  >
                    Prepared for :
                  </strong>

                  <span>Mr. {documentData?.leadId?.name}</span>
                </div>

                <div
                  style={{
                    display: "flex",
                    gap: "10px",
                  }}
                >
                  <strong
                    style={{
                      color: "#5d5d5d",
                      fontSize: "14px",
                    }}
                  >
                    Email :
                  </strong>

                  <span>{documentData?.leadId?.email}</span>
                </div>
              </div>

              {/* RIGHT */}

              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "6px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    gap: "10px",
                  }}
                >
                  <strong
                    style={{
                      color: "#5d5d5d",
                      fontSize: "14px",
                    }}
                  >
                    Date :
                  </strong>

                  <span>{new Date().toLocaleDateString()}</span>
                </div>

                <div
                  style={{
                    display: "flex",
                    gap: "10px",
                  }}
                >
                  <strong
                    style={{
                      color: "#5d5d5d",
                      fontSize: "14px",
                    }}
                  >
                    Mobile :
                  </strong>

                  <span>{documentData?.leadId?.phone}</span>
                </div>
              </div>
            </div>
          </div>
          {/* TOP */}

          <div className="main-content">
            {/* LEFT */}

            <div className="left-section">
              <h1
                style={{
                  fontSize: "36px",
                  lineHeight: "41px",
                  color: "#5a140c",
                  marginBottom: "25px",
                  fontWeight: "700",
                }}
              >
                PROJECT
                <br />
                PROPOSAL
              </h1>

              <div
                style={{
                  overflowY: "auto",
                  scrollbarWidth: "none",
                  msOverflowStyle: "none",
                }}
              >
                <div
                  style={{
                    fontSize: "15px",
                    lineHeight: "28px",
                    color: "#4b4b4b",
                    marginBottom: "30px",
                  }}
                >
                  We are excited to present this proposal for your
                  consideration. This document outlines the scope, deliverables,
                  timeline and our approach to deliver exceptional results.
                </div>

                <div
                  style={{
                    width: "120px",
                    height: "2px",
                    background: "#8b3d31",
                    marginBottom: "24px",
                  }}
                />

                {/* HTML CONTENT */}

                <div
                  style={{
                    flex: 1,
                    // overflowY: "auto",
                    paddingRight: "10px",
                  }}
                >
                  <div
                    className="custom-html-content"
                    dangerouslySetInnerHTML={{
                      __html: html,
                    }}
                  />
                </div>
              </div>
            </div>

            {/* RIGHT */}

            <div className="right-section">
              <div>
                {/* QUOTE */}

                <div
                  style={{
                    width: "100%",

                    borderRadius: "22px",
                    overflow: "hidden",
                    textAlign: "center",
                    marginTop: "40px",
                    marginBottom: "25px",
                  }}
                >
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/img/laptop-img.png`}
                    alt="proposal"
                    className="proposal-image"
                  />
                </div>
              </div>

              {/* BUTTONS */}

              {!actionDone && (
                // <motion.div
                //   initial={{
                //     opacity: 0,
                //     y: 40,
                //   }}
                //   animate={{
                //     opacity: 1,
                //     y: 0,
                //   }}
                //   transition={{
                //     duration: 0.6,
                //   }}
                //   style={{
                //     display: "flex",
                //     justifyContent: "center",
                //     gap: "22px",
                //     marginBottom: "20px",
                //   }}
                // >
                <motion.div className="proposal-btn-wrapper">
                  {/* PROCEED BUTTON */}
                  {hasPrice && (
                    <motion.button
                      onClick={() => handleStatus("accepted")}
                      whileHover={{
                        scale: 1.04,
                        y: -4,
                      }}
                      whileTap={{
                        scale: 0.97,
                      }}
                      transition={{
                        type: "spring",
                        stiffness: 260,
                        damping: 15,
                      }}
                      style={{
                        position: "relative",
                        overflow: "hidden",

                        border: "none",

                        background: "linear-gradient(135deg,#5a140c,#8f2a1c)",

                        color: "#fff",

                        padding: "18px 30px",

                        borderRadius: "18px",

                        cursor: "pointer",

                        minWidth: "240px",

                        display: "flex",

                        alignItems: "center",

                        justifyContent: "space-between",

                        gap: "18px",

                        boxShadow: "0 14px 35px rgba(123,20,8,0.28)",

                        transition: "0.3s",
                      }}
                    >
                      {/* GLOW */}

                      <div
                        style={{
                          position: "absolute",
                          width: "140px",
                          height: "140px",
                          background: "rgba(255,255,255,0.08)",

                          borderRadius: "50%",

                          top: "-60px",

                          right: "-40px",
                        }}
                      />

                      {/* LEFT */}

                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "14px",
                          zIndex: 2,
                        }}
                      >
                        <div
                          style={{
                            width: "52px",
                            height: "52px",
                            borderRadius: "16px",
                            background: "rgba(255,255,255,0.16)",

                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",

                            fontSize: "22px",

                            backdropFilter: "blur(10px)",
                          }}
                        >
                          🤝
                        </div>

                        <div
                          style={{
                            textAlign: "left",
                          }}
                        >
                          <div
                            style={{
                              fontWeight: "700",
                              fontSize: "18px",
                              marginBottom: "4px",
                            }}
                          >
                            Let’s Proceed
                          </div>

                          <div
                            style={{
                              fontSize: "13px",
                              opacity: 0.82,
                            }}
                          >
                            Continue agreement process
                          </div>
                        </div>
                      </div>

                      {/* RIGHT ARROW */}

                      <motion.div
                        animate={{
                          x: [0, 6, 0],
                        }}
                        transition={{
                          repeat: Infinity,
                          duration: 1.5,
                        }}
                        style={{
                          fontSize: "22px",
                          zIndex: 2,
                        }}
                      >
                        →
                      </motion.div>
                    </motion.button>
                  )}

                  {/* CONTACT SALES */}

                  <motion.button
                    className="proposal-btn proposal-btn-primary"
                    onClick={() => handleStatus("contact_sales")}
                  >
                    {" "}
                    {/* BG CIRCLE */}
                    <div
                      style={{
                        position: "absolute",

                        width: "130px",

                        height: "130px",

                        background: "rgba(123,20,8,0.04)",

                        borderRadius: "50%",

                        top: "-60px",

                        right: "-30px",
                      }}
                    />
                    {/* LEFT */}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "14px",
                        zIndex: 2,
                      }}
                    >
                      <div
                        style={{
                          width: "52px",
                          height: "52px",
                          borderRadius: "16px",

                          background: "rgba(123,20,8,0.08)",

                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",

                          fontSize: "22px",
                        }}
                      >
                        📞
                      </div>

                      <div
                        style={{
                          textAlign: "left",
                        }}
                      >
                        <div
                          style={{
                            fontWeight: "700",
                            fontSize: "18px",
                            marginBottom: "4px",
                          }}
                        >
                          Contact Sales
                        </div>

                        <div
                          style={{
                            fontSize: "13px",
                            opacity: 0.72,
                          }}
                        >
                          Need help before proceeding?
                        </div>
                      </div>
                    </div>
                    {/* ICON */}
                    <motion.div
                      animate={{
                        rotate: [0, -8, 8, 0],
                      }}
                      transition={{
                        repeat: Infinity,
                        duration: 2,
                      }}
                      style={{
                        fontSize: "22px",
                        zIndex: 2,
                        marginLeft: "auto",
                      }}
                    >
                      ☎
                    </motion.div>
                  </motion.button>
                </motion.div>
              )}
            </div>
          </div>

          {/* FOOTER */}

          <div className="document-footer">
            {/* BOX 1 */}

            <div
              className="footer-box"
              style={{
                display: "flex",
                gap: "14px",
                borderRight: "1px solid #d8c7c0",
                paddingRight: "16px",
              }}
            >
              <div
                style={{
                  width: "80px",
                  height: "50px",
                  background: "#5a140c",
                  borderRadius: "14px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <img
                  src="https://img.icons8.com/ios/50/FFFFFF/shop--v1.png"
                  alt="shop"
                  style={{
                    width: "30px",
                    height: "30px",
                    objectFit: "contain",
                  }}
                />
              </div>

              <div>
                
                <div
                  style={{
                    fontWeight: "700",
                    color: "#5a140c",
                    fontSize: "15px",
                    marginBottom: "6px",
                  }}
                >
                  Axepert Exhibits Pvt Ltd
                </div>

                <div
                  style={{
                    lineHeight: "16px",
                    color: "#555",
                    fontSize: "10px",
                  }}
                >
                  KD-3,Pitampura, New Delhi -110034.
                  <br />
                  mail@axesell.com
                  <br />
                 +91 11 43710041
                </div>
              </div>
            </div>

            {/* BOX 2 */}

            <div
              style={{
                borderRight: "1px solid #d8c7c0",
                paddingRight: "15px",
              }}
            >
              <div
                style={{
                  fontSize: "24px",
                }}
              >
                <img
                  width="50"
                  height="50"
                  src="https://img.icons8.com/ios/50/521a10/security-checked--v1.png"
                  alt="security-checked--v1"
                  style={{
                    width: "30px",
                    height: "30px",
                    objectFit: "contain",
                  }}
                />
              </div>

              <h3
                style={{
                  color: "#5a140c",
                  fontSize: "15px",
                  marginBottom: "8px",
                }}
              >
                Trusted & Secure
              </h3>

              <p
                style={{
                  color: "#666",
                  lineHeight: "22px",
                  fontSize: "12px",
                }}
              >
                Your data is safe with us.
              </p>
            </div>

            {/* BOX 3 */}

            <div
              style={{
                borderRight: "1px solid #d8c7c0",
                paddingRight: "15px",
              }}
            >
              <div
                style={{
                  fontSize: "24px",
                }}
              >
                <img
                  width="64"
                  height="64"
                  src="https://img.icons8.com/wired/64/521a10/online-support--v2.png"
                  alt="online-support--v2"
                  style={{
                    width: "30px",
                    height: "30px",
                    objectFit: "contain",
                  }}
                />
              </div>

          <h3
  style={{
    color: "#5a140c",
    fontSize: "15px",
    marginBottom: "8px",
  }}
>
  Working Hours
</h3>

<p
  style={{
    color: "#666",
    lineHeight: "22px",
    fontSize: "12px",
  }}
>
  Our support team is available Monday to Friday, 9:30 AM – 6:30 PM, to assist you promptly.
</p>

             
            </div>

            {/* BOX 4 */}

            <div
              style={{
                borderRight: "1px solid #d8c7c0",
                paddingRight: "15px",
              }}
            >
              <div
                style={{
                  fontSize: "24px",
                }}
              >
                <img
                  width="48"
                  height="48"
                  src="https://img.icons8.com/parakeet-line/48/521a10/user-group-man-woman.png"
                  alt="user-group-man-woman"
                  style={{
                    width: "30px",
                    height: "30px",
                    objectFit: "contain",
                  }}
                />
              </div>

              <h3
                style={{
                  color: "#5a140c",
                  fontSize: "15px",
                  marginBottom: "8px",
                }}
              >
                Client Satisfaction
              </h3>

              <p
                style={{
                  color: "#666",
                  lineHeight: "22px",
                  fontSize: "12px",
                }}
              >
                We are committed to your success.
              </p>
            </div>

            {/* BOX 5 */}

            <div>
              <h2
                style={{
                  color: "#5a140c",
                  fontSize: "26px",
                  lineHeight: "34px",
                  marginBottom: "8px",
                }}
              >
                Thank You!
              </h2>

              <p
                style={{
                  color: "#666",
                  lineHeight: "22px",
                  fontSize: "12px",
                }}
              >
                We look forward to working with you.
              </p>
            </div>
          </div>
        </div>
      </div>
    </PageTransition>
  );
}

export default DocumentView;
